import { Injectable } from '@angular/core';

import { HttpService } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DeliveryMonthReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('DeliveryMonthReference', httpService);
  }
}
